import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef
} from '@angular/core';
import { MaturityChartComponent } from '../maturity-chart/maturity-chart.component';
import { CommonService } from 'app/core/services/common.service';
import { ChartsCommonService } from '../../../services/charts-common.service';
import { ChartsDashboardQuery } from '../../../state/dashboard';
import {
  ChartsDashboardSeriesQuery,
  IChartSeries
} from '../../../state/series';
import { ChartsDashboardCardQuery } from '../../../state/card';
import { ChartsHttpService } from '../../../services/charts-http.service';
import { ChartsDashboardStateService } from '../../../state/charts-dashboard-state.service';
import { Observable } from 'rxjs';
import {
  AxisXMaturity,
  ChartFilterPatternNameEnum,
  Datetime,
  IChartFilter,
  IChartPointsResponse,
  IHistoricalPointsData,
  ILCPoint,
  IMappedSeriesPointsResponse,
  ISkewChartParameters,
  RealTimeEnum
} from '../../../interfaces';
import * as moment from 'moment';
import {
  getNYTime,
  momentDateFormat,
  momentDateTimeFormat
} from '../../../helpers/charts-module-helpers';
import { map } from 'rxjs/operators';
import {
  LineSeries,
  SeriesXY
} from '@arction/lcjs';

@Component({
  selector: 'iv-live-skew-chart',
  templateUrl: '../common-chart/common-chart.component.html',
  styleUrls: ['../common-chart/common-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkewChartComponent extends MaturityChartComponent {

  constructor(
    protected readonly commonService: CommonService,
    protected readonly chartsCommonService: ChartsCommonService,
    protected readonly elementRef: ElementRef,
    protected readonly changeDetectorRef: ChangeDetectorRef,
    protected readonly dashboardQuery: ChartsDashboardQuery,
    protected readonly seriesQuery: ChartsDashboardSeriesQuery,
    protected readonly cardsQuery: ChartsDashboardCardQuery,
    protected readonly httpService: ChartsHttpService,
    protected readonly chartsState: ChartsDashboardStateService
  ) {

    super(
      commonService,
      chartsCommonService,
      elementRef,
      changeDetectorRef,
      dashboardQuery,
      seriesQuery,
      cardsQuery,
      httpService,
      chartsState
    );
  }

  protected setCursorResultTableFormatter(lineSeries: LineSeries, series: IChartSeries, filters?: IChartFilter[]): void {
    if (!lineSeries) return;

    lineSeries
      .setCursorResultTableFormatter((builder, _series: SeriesXY, x: number, y: number, dataPoint: ILCPoint) => {
        this.builderCursorResult = builder;

        this.builderCursorResult
          .addRow(`${moment(getNYTime(series.selectedFilters.datetime), 'MM-DD-YYYY HH:mm:ss A').format(momentDateFormat)}`)
          .addRow(`${this.cursorResult.x}: ${(this.pointsData as IHistoricalPointsData)[series.id]?.points[Math.round(x)].x}`)
          .addRow(`${this.cursorResult.y}: ${_series.axisY.formatValue(y)}`)
          .addRow(`${this.cursorResult.z}: ${dataPoint.z}`)
          .addRow(`${this.card.filters
            .find(filter => filter.parameterId === ChartFilterPatternNameEnum.IVX_TERM).name}: ${series.selectedFilters.ivxTerm.description}`);

        return this.builderCursorResult;
      });
  }

  protected createSeriesObservables(seriesArr: IChartSeries[]): Observable<IMappedSeriesPointsResponse<AxisXMaturity>>[] {
    return seriesArr.map((series: IChartSeries) => {
      return this.httpService.getSkewChart(this.getChartsParams(series) as ISkewChartParameters)
        .pipe(map((data: IChartPointsResponse<AxisXMaturity>) => {
          return {
            ...data,
            seriesId: series.id
          };
        }));
    });
  }

  protected getChartsParams(series: IChartSeries): ISkewChartParameters {
    if (!series) return;

    return {
      stockId: series.stock.stockId.toString(),
      symbol: series.stock.symbol,
      ivxTerm: series.selectedFilters.ivxTerm.name,
      regionId: series.stock.regionId,
      realtime: series.selectedFilters.realtime?.name,
      datetime: series.selectedFilters.realtime.name === RealTimeEnum.OFF
        ? (moment(new Date(series.selectedFilters?.datetime), 'MM-DD-YYYY HH:mm:ss A').isValid()
          ? moment(new Date(series.selectedFilters?.datetime), 'MM-DD-YYYY HH:mm:ss A').format(momentDateTimeFormat) as Datetime
          : undefined)
        : undefined,
      sendUserMetrics: !this.isSentUserMetrics && this.mainSeries.id === series.id
    };
  }
}
